<template>
  <div>
    <a-row>
      <a-col :span="16">
        <a-descriptions :column="3" style="margin-bottom: -15px">
          <a-descriptions-item :label="$t('button.scanBarcode')">
            <vxe-input ref="_container" v-model="scanBarcode" @keydown.native.enter="getData"/>
          </a-descriptions-item>
          <a-descriptions-item :label="$t('button.associativeEmptyBox')">
            <vxe-input ref="_connectBox" v-model="associativeEmptyBox" @keydown.native.enter="connectBox"/>
          </a-descriptions-item>
          <a-descriptions-item :label="$t('button.bindExchangeBoxBarcode')">
            <vxe-input v-model="bindExchangeBoxBarcode" @keydown.native.enter="bind()"/>
          </a-descriptions-item>
          <a-descriptions-item :label="$t('business.label.itemNo')">
            <span class="normalFont">{{this.selectedCmd.item.no}}</span>
          </a-descriptions-item>
          <a-descriptions-item :label="$t('business.label.itemName')">
            <span class="normalFont">{{this.selectedCmd.item.name}}</span>
          </a-descriptions-item>
          <a-descriptions-item :label="$t('business.label.lotNo')">
            <span class="normalFont">{{this.selectedCmd.lot.no}}</span>
          </a-descriptions-item>
          <a-descriptions-item :label="$t('business.label.specification')">
            <span class="normalFont">{{this.selectedCmd.pack.specification}}</span>
          </a-descriptions-item>
          <a-descriptions-item :label="$t('business.label.sourceContainer')">
            <span class="normalFont">{{this.selectedCmd.container.no}}</span>
          </a-descriptions-item>
          <a-descriptions-item :label="$t('business.label.factor')">
            <span class="normalFont">{{this.selectedCmd.pack.factor}}</span>
          </a-descriptions-item>
          <a-descriptions-item :label="$t('business.label.uom')">
            <span class="normalFont">{{this.selectedCmd.pack.uom}}</span>
          </a-descriptions-item>
          <a-descriptions-item :label="$t('business.label.targetContainer')">
            <span class="normalFont">{{this.targetContainer.no}}</span>
          </a-descriptions-item>
          <a-descriptions-item :label="$t('business.label.validUntil')">
            <span class="normalFont">{{this.selectedCmd.lot.validUntil}}</span>
          </a-descriptions-item>
          <a-descriptions-item :label="$t('business.label.manufacturer')">
            <span class="normalFont">{{this.selectedCmd.lot.manufacturer}}</span>
          </a-descriptions-item>
          <a-descriptions-item :label="$t('business.label.quantity')">
            <span class="normalFont">{{this.selectedCmd.quantity}}</span>
          </a-descriptions-item>
          <a-descriptions-item :label="$t('business.label.changeBoxQuantity')">
            <vxe-number-input ref="_exchangeQuantity" v-model="changeBoxQuantity" style="font-size: large;color: red" @keydown.native.enter="quantityConfirm"/>
          </a-descriptions-item>
        </a-descriptions>
      </a-col>
      <a-col :span="8">
        <a-card style="width: 100%">
          <img slot="cover" alt="example" src="@/assets/example.jpeg" style="height: 200px"/>
        </a-card>
      </a-col>
    </a-row>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      :height="scrollY"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      style="margin-top: 2px"
      @cell-click="({row})=>click(row)">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="taskType" title="business.label.taskType"/>
      <vxe-column field="item.name" title="business.label.itemName"/>
      <vxe-column field="item.no" title="business.label.itemNo"/>
      <vxe-column field="pack.specification" title="business.label.specification"/>
      <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
      <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
      <vxe-column field="container.no" title="business.label.sourceContainer"/>
      <vxe-column field="lot.no" title="business.label.lot"/>
      <vxe-column field="lot.productionDate" title="business.label.productionDate" width="100"/>
      <vxe-column field="lot.validUntil" title="business.label.validUntil" width="100"/>
      <vxe-column field="lot.approvalNo" title="business.label.approvalNo" width="150"/>
      <vxe-column field="quantity" title="business.label.quantity"/>
    </vxe-table>
  </div>
</template>
<script>
import Vue from 'vue'
import api from '@/api'
import { OPERATOR, SCREEN_HEIGHT, WAREHOUSE } from '@/store/mutation-types'
import { mixin, mixinDevice } from '@/utils/mixin'
import moment from 'moment'
import { findAll, findEnum, findOne, post } from '@/api/Api'
import { ShipmentExchangeFactoryView } from '@/api/dto/view/ShipmentExchangeFactoryView'
import { Container } from '@/api/dto/common/Container'

export default {
  name: 'ExchangeBox',
  components: {},
  mixins: [mixin, mixinDevice],
  data() {
    return {
      operator: Vue.ls.get(OPERATOR),
      warehouse: Vue.ls.get(WAREHOUSE),
      loading: false,
      data: [],
      scanBarcode: '',
      associativeEmptyBox: '',
      bindExchangeBoxBarcode: '',
      targetContainer: new Container(),
      changeBoxQuantity: 0,
      selectedCmd: new ShipmentExchangeFactoryView(),
      appendageSignData: [],
      scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.6325)
    }
  },
  mounted() {
    findEnum('AppendageSign').then(res => {
      this.appendageSignData = res.result
    })
  },
  methods: {
    click(row) {
      Object.assign(this.selectedCmd, row)
    },
    moment,
    getData() {
      if (this.scanBarcode === '') {
        return this.$warning({
          title: '请先扫描条码',
          centered: true,
          okText: '确定'
        })
      }
      this.loading = true
      findAll('exchangeShipmentFactory', { 'container.no': this.scanBarcode }).then(res => {
        if (res.success) {
          this.data = res.result
          if (this.data.length > 0) {
            this.$refs.table.setRadioRow(this.data[0])
            this.$refs.table.setCurrentRow(this.data[0])
            this.click(this.data[0])
            this.changeBoxQuantity = this.data[0].quantity
            this.$refs._connectBox.focus()
          } else {
            this.clean()
            this.refs._container.focus()
          }
        }
      }).finally(() => this.loading = false)
    },
    connectBox() {
      if (this.associativeEmptyBox === '') {
        return this.$warning({
          title: '请先扫描空箱',
          centered: true,
          okText: '确定'
        })
      }
      this.loading = true
      findOne('containerFactory', { 'container.no': this.associativeEmptyBox }).then(res => {
        if (res.success) {
          this.targetContainer = new Container(res.result)
          this.$refs._exchangeQuantity.focus()
        }
      }).finally(() => this.loading = false)
    },
    clean() {
      this.changeBoxQuantity = 0
      this.selectedCmd = new ShipmentExchangeFactoryView()
      this.associativeEmptyBox = ''
      this.scanBarcode = ''
    },
    quantityConfirm() {
      if (this.changeBoxQuantity <= 0) {
        return this.$warning({
          title: '请输入换箱数量!',
          centered: true,
          okText: '确定'
        })
      }
      if (this.changeBoxQuantity > this.selectedCmd.quantity) {
        return this.$warning({
          title: '换箱数量大于实际数量!',
          centered: true,
          okText: '确定'
        })
      }
      if (this.targetContainer.isNew()) {
        return this.$warning({
          title: '请输入换箱容器!',
          centered: true,
          okText: '确定'
        })
      }
      this.loading = true
      const args = {
        'operationType': this.selectedCmd.operationType,
        'source': this.selectedCmd.container.no,
        'target': this.targetContainer.no,
        'quantity': this.changeBoxQuantity
      }
      post(api.exchangingExchange, { type: 'containerExchanger' }, args).then(res => {
        if (res.success) {
          this.$message.success('换箱成功')
          this.targetContainer = new Container()
          this.selectedCmd = new ShipmentExchangeFactoryView()
          this.getData()
        }
      }).finally(() => this.loading = false)
    },
    bind() {
      if (!this.bindExchangeBoxBarcode) {
        return this.$warning({
          title: '请输入数据!',
          centered: true,
          okText: '确定'
        })
      }
      this.loading = true
      const args = {
        'container.no': this.bindExchangeBoxBarcode
      }
      post(api.exchangingPositionBind, {}, args).then(res => {
        if (res.success) {
          this.$message.success('箱号【' + this.bindExchangeBoxBarcode + '】绑定换箱站成功')
          this.this.bindExchangeBoxBarcode = null
        }
      }).finally(() => this.loading = false)
    }
  }
}
</script>
<style scoped>
.normalFont {
  font-weight: bold;
  font-size: 18px;
  color: #404040;
}
</style>